import React, { useRef, useEffect, useContext } from "react";
import { useTranslation } from "react-i18next";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  Filler,
} from "chart.js";
import { Line } from "react-chartjs-2";
import { MediaContext } from "../../context/MediaContext";
import { SocketContext } from "../../context/SocketContext";
import zoomPlugin from "chartjs-plugin-zoom";

/* Line chart that shows the understanding % trend of the students that were connected to the lecture from the start to the end of it.*/
const AsyncLineChart = () => {
  const { t } = useTranslation("", { keyPrefix: "components.charts" });

  const { syncUnderstandings } = useContext(SocketContext);
  const { player } = useContext(MediaContext);
  const duration = useRef(60 * 60);

  useEffect(() => {
    if (player) {
      duration.current = player.getDuration();
    }
  }, [player, syncUnderstandings]);

  ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend, zoomPlugin, Filler);

  const prepareData = () => {
    return syncUnderstandings.map((u) => ({ x: u.videoTs, y: u.percentage }));
  };

  const options = {
    maintainAspectRatio: false,
    scales: {
      y: {
        min: 0,
        max: 1,
      },
      x: {
        type: "linear",
        beginAtZero: true,
        min: 0,
        max: duration.current,
        ticks: {
          beginAtZero: true,
          callback: (tick) =>
            Math.floor(tick / 60) + ":" + (tick % 60 < 10 ? "0" + Math.floor(tick % 60) : Math.floor(tick % 60)),
        },
      },
    },
    plugins: {
      legend: {
        display: false,
      },
      title: {
        display: false,
      },
      zoom: {
        limits: {
          x: { min: 0, max: duration, minRange: 5 },
        },
        zoom: {
          wheel: {
            enabled: true, // SET SCROLL ZOOM TO TRUE
          },
          mode: "x",
          speed: 0.1,
        },
        pan: {
          enabled: true,
          mode: "x",
        },
      },
    },
    interaction: {
      mode: "point",
    },
    onClick: (e, element) => {
      if (element.length > 0) {
        var ind = element[0].index;
        var point = data.datasets[0].data[ind]; //point.x = videoSeconds
        player.seekTo(point.x);
      }
    },
  };

  const data = {
    datasets: [
      {
        label: t("clearity"),
        data: prepareData(),
        backgroundColor: "rgba(75,192,192,0.5)",
        borderDash: [],
        fill: true,
        borderDashOffset: 1.0,
        borderJoinStyle: "miter",
        pointBorderColor: "rgba(75,192,192,1)",
        pointBackgroundColor: "#fff",
        pointBorderWidth: 2,
        pointHoverRadius: 10,
        pointHoverBackgroundColor: "rgba(0,0,233,1)",
        pointHoverBorderColor: "rgba(220,220,220,1)",
        pointHoverBorderWidth: 2,
        pointHitRadius: 10,
      },
    ],
  };

  return (
    <div className="h-100">
      <Line options={options} data={data} />
    </div>
  );
};

export default AsyncLineChart;
